import React from "react";

/**
 * Top page details
 */
const OpeningDetails = () => {


    return (
        <div className="lg:mr-6 lg:w-2/3 xl:width-70p pb-6">
            <h1 className="waves-h1">
                Waves System Builder
            </h1>
            <div className="w-full">
                <div className="col-xs-12 start-xs">
                    <div className="col-xs-12 col-lg-8 start-xs no-pad" >Select or build your
                        Waves live mixing system: Each system includes <b>eMotion LV1</b> live mixer
                        or <b>SuperRack</b> plugin rack software, plus accompanying hardware. Even if you select an
                        existing system, you can modify it by adding or replacing individual components below.
                    </div>
                    <div className="pt-4 col-xs-12 start-xs">
                        <div className="col-xs-12 col-lg-8 start-xs no-pad"><b>Please note</b>:
                            The systems selected via the System Builder do not include plugins (except the eMo
                            plugins included in every eMotion LV1 purchase). Plugins can be purchased separately <a
                                className="blue9-link" href="/specials">here</a>.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OpeningDetails;
